import { L, cls, plusOneYear } from "./assetShared";

// poliçe başlangıç (girilir) + bitiş (başlangıç + 1 yıl, kilitli)
export default function PolicyDates({ prefix, k, label, data, onChange }) {
  const start = data[`${k}_start`] || "";
  const end = data[`${k}_end`] || "";
  return (
    <>
      <L label={`${label} Başlangıç`}>
        <input type="date" data-testid={`${prefix}-field-${k}_start`} value={start} className={cls}
          onChange={(e) => onChange({ [`${k}_start`]: e.target.value, [`${k}_end`]: plusOneYear(e.target.value) })} />
      </L>
      <L label={`${label} Bitiş (otomatik, 1 yıl)`}>
        <input type="date" data-testid={`${prefix}-field-${k}_end`} value={end} readOnly disabled title="Başlangıç tarihinden 1 yıl sonrası — otomatik hesaplanır"
          className={`${cls} bg-slate-100 text-slate-600 cursor-not-allowed`} />
      </L>
    </>
  );
}
